import { IUser } from 'types/common';

import { getSelectOptions } from 'utils/getSelectOptions';

export const getUsersOptions = (users: Array<IUser>) =>
  getSelectOptions(users, 'id', userLabel => userLabel.username);
